import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
  DialogActions,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { Service } from "../_generated";
import { useForm } from "react-hook-form";
import { TabbedRepositorySelector } from "../components/TabbedRepositorySelector";
import {
  ServiceContainerFields,
  ServiceWebappFields,
} from "../components/ServiceFields";
export type UserRepository = {
  name: string;
};

export type UserAppInstallation = {
  id: number;
};

export default function ServiceInitDialog(props: {
  open: boolean;
  service?: Service;
  onCancel: () => any;
  onSubmit: (data: Service) => any;
  onChooseDatabase: () => any;
  projectName: string;
}) {
  const [serviceType, setServiceType] = useState("");
  const [selectedRepoInfo, setSelectedRepoInfo] = useState(
    {} as { name: string; type: string }
  );
  const { register, handleSubmit, errors } = useForm();

  let dialogContent;
  if (serviceType === "") {
    dialogContent = (
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1">Resources</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} direction="row">
          <Grid item xs={6}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => props.onChooseDatabase()}
            >
              Postgres database
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" color="primary" fullWidth disabled>
              DynamoDB
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" color="primary" fullWidth disabled>
              Redis
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" color="primary" fullWidth disabled>
              ElasticSearch
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    );
  } else {
    dialogContent = (
      <DialogContent>
        <Grid container spacing={2} direction="column" alignItems="flex-start">
          <Grid item xs={12}>
            <TabbedRepositorySelector
              selectedRepoInfo={selectedRepoInfo}
              projectName={props.projectName}
              onChange={setSelectedRepoInfo}
            />
          </Grid>
          <Grid item xs={12}>
            {serviceType === "container" && (
              <ServiceContainerFields
                service={props.service}
                register={register}
                errors={errors}
              />
            )}
            {serviceType === "webapp" && (
              <ServiceWebappFields
                service={props.service}
                register={register}
                errors={errors}
              />
            )}
          </Grid>
        </Grid>
      </DialogContent>
    );
  }

  return (
    <Dialog open={props.open} fullWidth onEnter={() => setServiceType("")}>
      <form
        onSubmit={handleSubmit((data: any) => {
          if (!selectedRepoInfo.name || !selectedRepoInfo.type) {
            alert("please select a repository!");
            return;
          }
          return props.onSubmit({
            ...props.service,
            ...data,
            service_type: serviceType,
            repository: selectedRepoInfo.name,
            repository_type: selectedRepoInfo.type,
          });
        })}
      >
        <DialogTitle>New Resource</DialogTitle>
        {dialogContent}
        <DialogActions>
          <Button onClick={props.onCancel}>Cancel</Button>
          {serviceType && (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disableElevation
            >
              Create
            </Button>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
}
